import React, { useState } from 'react';
import Select from 'react-select';

export default function ReactSelect({ label, placeholder, options = [], value, onChange }) {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  // Handle when the dropdown should open
  const handleMenuOpen = () => {
    setMenuIsOpen(true);
  };

  // Handle when the dropdown should close
  const handleMenuClose = () => {
    setMenuIsOpen(false);
  };

  // Handle when a selection is made
  const handleChange = (selectedOption) => {
    // Find the selected item from the options array
    const selectedItem = options.find((item) => item.value === selectedOption.value);
    // console.log(selectedItem && selectedItem.description && selectedItem.description.trim() !== '')
    // Update the selected value in the parent component first
    onChange(selectedOption);

    // Then, based on the description, control whether to keep the menu open or close it
    if (selectedItem.description) {
      // Keep the menu open if a valid description exists
      setMenuIsOpen(true);
    } else {
      // Close the menu if no description exists
      setMenuIsOpen(false);
    }
  };

  // Custom styles for react-select with border radius and padding
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: '10px',
      padding: '5px',
      border: state.isFocused ? '1px solid #007bff' : '1px solid #ccc',
      boxShadow: state.isFocused ? '0 0 0 1px #007bff' : 'none',
      '&:hover': {
        border: state.isFocused ? '1px solid #007bff' : '1px solid #999',
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '10px',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'rgba(96, 96, 96, 0.8)',
      opacity: 0.8,
      fontWeight: 600,
    }),
  };

  return (
    <div>
      <label>{label}</label>
      <Select
        value={value} // Make sure the value prop is an object { value, text }
        onChange={handleChange} // Handle the selection change
        options={options} // Ensure the options prop has { value, text, description }
        placeholder={placeholder}
        menuIsOpen={menuIsOpen} // Control the menu's open state manually
        onMenuOpen={handleMenuOpen} // Handle opening the menu
        onMenuClose={handleMenuClose}
        // Handle closing the menu
        getOptionLabel={(option) =>
            option.description ? `${option.text} ${option.description}` : option.text
          }  // Use the 'text' field as the label
        getOptionValue={(option) => option.value}
        closeMenuOnSelect={false}
        blurInputOnSelect={false}// Use the 'value' field as the value
        styles={customStyles} // Apply custom styles
      />
    </div>
  );
}
